// extracted by mini-css-extract-plugin
export var container = "_2v-0";